var optionList = 'fx_2d2fb1e5_ew27un1';

export { optionList };
//# sourceMappingURL=optionList.vanilla.mjs.map
